module.exports = __webpack_public_path__ + "static/img/15203089231.5c12df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15203089231.jpg
// module id = fxvn
// module chunks = 0